import React, {Component} from 'react';

import Input from 'Components/Input'
import Checkbox from 'Components/Checkbox';
import Dropdown from 'Components/Dropdown';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';

import PlacesAutoComplete from 'Components/PlacesAutoComplete';

import { LEGS_TYPES, TAT_UNITS } from 'Constants/commonConstants';

class LCLStopDetails extends Component {
    constructor(props) {
        super(props);
        this.trip = props.trip;
        this.viewMode = props.viewMode;
        this.legs = this.trip.legs;
        this.state = {
            legs: this.trip.legs,
        }
    }
    
    setFromLocation = (index, location)=> {
        if(this.viewMode) {
            return;
        }
        this.legs[index].setFromLocation(location);
        this.setState({
            legs: this.legs
        })
        this.props.onChange();        
    }

    setToLocation = (index, location)=> {
        if(this.viewMode) {
            return;
        }
        this.legs[index].setToLocation(location);
        this.setState({
            legs: this.legs
        })
        this.props.onChange();

    }
    addLeg = ()=>{
        if(this.viewMode) {
            return;
        }
        this.props.trip.addLeg();
        this.setState({
            legs: this.props.trip.legs
        });
    }
    selectLegType = (index, legType, legTypeName)=> {
        if(this.viewMode) {
            return;
        }
        this.legs[index].setLegType(legType, legTypeName);
        this.setState({
            legs: this.legs
        })
    }
    onChange = (index, e)=> {
        if(this.viewMode) {
            return;
        }
        const name = e.target.name;
        const value = e.target.value;
        this.legs[index]['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            legs: this.legs
        });
    }
    onSelect = (index, value, name)=> {
        if(this.viewMode) {
            return;
        }
        this.legs[index]['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        this.setState({
            legs: this.legs
        });
    }
    removeLeg = (index)=>{
        if(this.viewMode) {
            return;
        }
        this.trip.removeLeg(index);
        this.setState({
            legs: this.trip.legs
        });
    }
    render() {
        const { legs } = this.state;
        const {
            businessVolumes,
            pricingBasis
        } = this.props
        return (
            <div className="">
                {
                    legs.map((leg, index)=> {
                        return (
                            <div key={leg.id} className="border-status-bar br-5 pl-10 pr-10 pt-20 pb-20 mb-30 pr">
                                {legs.length > 1 && <CloseIcon className="pa t--15 r--15 curP" onClick={this.removeLeg.bind(this, index)}/>}
                                <div className="header-medium-color fBold fs-20 mb-20">Leg {index + 1}</div>
                                <div className="flex flex-between mb-30">
                                    <div className="col-2 mr-20">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">From</div>
                                        {!this.viewMode && <PlacesAutoComplete setLocation={this.setFromLocation.bind(this, index)} value={leg.from.location || ''}/>}
                                        {this.viewMode && <Input value={leg.to.location || ''}/>}
                                    </div>
                                    <div className="col-2">
                                        <div className="fSemibold fs-18 header-medium-color mb-5">To</div>
                                        {!this.viewMode && <PlacesAutoComplete setLocation={this.setToLocation.bind(this, index)} value={leg.to.location || ''}/>}
                                        {this.viewMode && <Input value={leg.to.location || ''}/>}
                                    </div>
                                </div>
                                <div className="fSemibold fs-18 header-medium-color mb-10">Leg Type</div>
                                <div className="flex flex-between wt-400 mb-30">
                                    {
                                        [...LEGS_TYPES].map((legType, checkboxIndex)=> {
                                            return (
                                                <Checkbox key={checkboxIndex} onCheck={this.selectLegType.bind(this,index, legType.value, legType.name)} checked={leg.legType === legType.value} label={legType.name}/>
                                            )
                                        })
                                    }
                                </div>
                                <div className="fSemibold fs-18 header-medium-color mb-5">Ceiling Price</div>
                                <div className="wt-150 mb-30">
                                    <Input placeholder="Ceiling Price" value={leg.qbr} onChange={this.onChange.bind(this, index)} name="qbr"/>
                                </div>

                                <div className="fSemibold fs-18 header-medium-color mb-5">TAT</div>
                                <div className="wt-300 mb-30 flex">
                                    <div className="wt-100 mr-20"><Input placeholder="TAT" value={leg.tatValue} onChange={this.onChange.bind(this, index)} name="tatValue"/></div>
                                    <Dropdown 
                                        items={[...TAT_UNITS]} 
                                        selectedItem={TAT_UNITS.find(tatUnit=>{return leg.tatUnit === tatUnit.value})}
                                        name="tatUnit"
                                        onSelect={this.onSelect.bind(this, index)}
                                        displayKey="name"
                                        className="flex-1"
                                        label="Select Unit"
                                    />
                                </div>

                                <div className="fSemib   old fs-18 header-medium-color mb-5">Business Volume</div>
                                <div className="wt-300 mb-30 flex">
                                    <div className="wt-100 mr-20"><Input placeholder="BV" value={leg.businessVolumeValue} onChange={this.onChange.bind(this, index)} name="businessVolumeValue"/></div>
                                    <Dropdown 
                                        items={businessVolumes} 
                                        selectedItem={businessVolumes.find(businessVolumeUnit=>{return leg.businessVolumeUnit === businessVolumeUnit.value})}
                                        name="businessVolumeUnit"
                                        onSelect={this.onSelect.bind(this, index)}
                                        displayKey="name"
                                        className="flex-1"
                                        label="Select Unit"
                                    />
                                </div>

                                <div className="fSemibold fs-18 header-medium-color mb-5">Heading Charges</div>
                                <div className="wt-300 flex">
                                    <div className="wt-100 mr-20"><Input placeholder="Charges" value={leg.headingChargesValue} onChange={this.onChange.bind(this, index)} name="headingChargesValue"/></div>
                                    <Dropdown 
                                        items={pricingBasis} 
                                        selectedItem={pricingBasis.find(pricingBasis=>{return leg.headingChargesUnit === pricingBasis.value})}
                                        name="headingChargesUnit"
                                        onSelect={this.onSelect.bind(this, index)}
                                        displayKey="name"
                                        className="flex-1"
                                        label="Select Unit"
                                    />
                                </div>
                             </div>
                        )   
                    })
                }
                <div className="flex flex-middle curP mt-30 wt-max-content" onClick={this.addLeg}>
                    <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                        <PlusIcon className="wt-15 ht-15"/>
                    </div>
                    <div className="fSemibold fs-16 fBold header-dark-color">Add Leg</div>
                </div>
            </div>
        )
    }
}

export default LCLStopDetails;
